import React, { useState } from "react";
import { userProfileService } from "../../services/userProfileService";
import { toast } from "react-toastify";
import { useAuth } from "../../context/auth";

const Home = () => {
  // 🧠 State variables
  const [userEmail, setUserEmail] = useState("");
  const [subEmail, setSubEmail] = useState("");
  const [accountType, setAccountType] = useState("");
  const [accountDate, setAccountDate] = useState("");
  const [verifyEmail, setVerifyEmail] = useState("");
  const [loading, setLoading] = useState(false)
    const [apiData, setApiData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const {getAdminAuthToken
   }= useAuth()

   console.log("homepage mounted")

   const token = getAdminAuthToken()
  // 🧾 Handlers
  const handleUserSubmit = () => {
    console.log("User Email Submitted:", userEmail);
  };

  const handleSubscribe = () => {
    console.log("Subscribed:", subEmail);
  };

  const handleUnsubscribe = () => {
    console.log("Unsubscribed:", subEmail);
  };

  const handleAccountSubmit = () => {
    console.log("Account Type:", accountType, "Date:", accountDate);
  };

  const handleVerifyMail = () => {
    console.log("Mail Verification:", verifyEmail);
  };

  const [email, setEmail] = useState("")


   const validEmail = (email = '') => {
        if ( !email) {
            return "Email is required";
        }
      

        return null;
    };

  
  const handleUserPorfile = async (e) => {
  e.preventDefault();

  // ✅ Validate email before API call
  try {
    const validationError = validEmail(email);
    if (validationError) {
      throw new Error(validationError);
    }
  } catch (error) {
    toast.error(error.message);
    return;
  }

  setLoading(true);

  const data = {
    e: email,
  };

  try {
    const response = await userProfileService(data, token);


    if (response.status === 200) {
      const resData = response.data;

  
      if (resData.error === true) {
        toast.error(
          <div className="p-4">
            <p className="mb-2 text-sm text-gray-800">
              {resData?.data || "Something went wrong."}
            </p>
          </div>
        );

        if (resData.mail_verification_error) {
          setLoading(false);
        }

        return;
      }

  
      if (!resData.mail_verification_error) {
        const adminMail = resData?.data?.mail;
        console.log("Mail:", adminMail);

        localStorage.setItem("admin_mail", adminMail);

        // 🔥 Set data and show popup
        setApiData(resData);
        setShowPopup(true);

        toast.success("User profile loaded successfully!");
      } else {
        toast.error(resData?.data || "Mail verification failed!");
      }
    } else {
      toast.error(response?.data?.data || "Something went wrong!");
    }
  } catch (error) {
    toast.error(error?.response?.data?.data || "Something went wrong!");
  } finally {
    setLoading(false);
  }
};

  
  
   
    const closePopup = () => setShowPopup(false);

  
  
  

  return (

    <div className="w-full h-screen flex justify-center sm:mt-0 mt-32 lg:mt-0 md:m-0 ">
    <div className="p-4 space-y-6 w-full flex flex-col justify-center ">
      {/* Section 1 - User Detail */}
      <section className="bg-white shadow-lg rounded-lg p-4  sm:mt-14 md:mt-11 ">
        <h2 className="text-lg font-semibold mb-3">User Detail</h2>
        <div className="flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border p-2 rounded flex-grow"
          />
          <button
            onClick={handleUserPorfile}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Submit
          </button>
        </div>
      </section>

        {/* Popup Modal */}
      {showPopup && apiData && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-11/12 max-w-2xl rounded-lg shadow-lg p-6 relative">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">
              API Response
            </h3>

            <div className="overflow-auto max-h-96 border rounded p-3 bg-gray-50 text-sm">
              <pre className="whitespace-pre-wrap break-words text-gray-700">
                {JSON.stringify(apiData, null, 2)}
              </pre>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
               <label className="flex items-center space-x-2">
    <input
      type="checkbox"
      checked={apiData?.data?.trading_block}
      readOnly
      className="h-4 w-4 text-blue-600 border-gray-300 rounded"
    />
    <span className="text-gray-700 text-sm font-medium">Trading Block</span>
  </label>
  <label className="flex items-center space-x-2">
    <input
      type="checkbox"
      checked={apiData?.data?.paid}
      readOnly
      className="h-4 w-4 text-blue-600 border-gray-300 rounded"
    />
    <span className="text-gray-700 text-sm font-medium">Paid</span>
  </label>

  <label className="flex items-center space-x-2">
    <input
      type="checkbox"
      checked={apiData?.data?.risk_passed}
      readOnly
      className="h-4 w-4 text-blue-600 border-gray-300 rounded"
    />
    <span className="text-gray-700 text-sm font-medium">Risk Passed</span>
  </label>

  <label className="flex items-center space-x-2">
    <input
      type="checkbox"
      checked={apiData?.data?.trading_pause}
      readOnly
      className="h-4 w-4 text-blue-600 border-gray-300 rounded"
    />
    <span className="text-gray-700 text-sm font-medium">Trading Paused</span>
  </label>

   <label className="flex items-center space-x-2">
    <input
      type="checkbox"
      checked={apiData?.data?.copier_permission}
      readOnly
      className="h-4 w-4 text-blue-600 border-gray-300 rounded"
    />
    <span className="text-gray-700 text-sm font-medium">Copier Permission</span>
  </label>
</div>


            <button
              onClick={closePopup}
              className="absolute top-2 right-3 text-gray-500 hover:text-red-500 text-2xl font-bold"
            >
              &times;
            </button>

            <div className="flex justify-end mt-4">
              <button
                onClick={closePopup}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-all"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Section 2 - Subscribe/Unsubscribe */}
      <section className="bg-white shadow-lg  rounded-lg p-4">
        <h2 className="text-lg font-semibold mb-3">Subscribe / Unsubscribe</h2>
        <div className="flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            placeholder="Email"
            value={subEmail}
            onChange={(e) => setSubEmail(e.target.value)}
            className="border p-2 rounded flex-grow"
          />
          <div className="flex gap-2">
            <button
              onClick={handleSubscribe}
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            >
              Subscribe
            </button>
            <button
              onClick={handleUnsubscribe}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Unsubscribe
            </button>
          </div>
        </div>
      </section>

      {/* Section 3 - Account Management */}
      <section className="bg-white shadow-lg rounded-lg p-4">
        <h2 className="text-lg font-semibold mb-3">Account Management</h2>
        <div className="flex flex-col sm:flex-row gap-3">
          <select
            value={accountType}
            onChange={(e) => setAccountType(e.target.value)}
            className="border p-2 rounded flex-grow"
          >
            <option value="">Select Account Type</option>
            <option value="Free">Free</option>
            <option value="Premium">Premium</option>
            <option value="Enterprise">Enterprise</option>
          </select>

          <input
            type="date"
            value={accountDate}
            onChange={(e) => setAccountDate(e.target.value)}
            className="border p-2 rounded flex-grow"
          />

          <button
            onClick={handleAccountSubmit}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Submit
          </button>
        </div>
      </section>

      {/* Section 4 - Mail Verification */}
      <section className="bg-white shadow-lg rounded-lg p-4">
        <h2 className="text-lg font-semibold mb-3">Mail Verification</h2>
        <div className="flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            placeholder="Enter Email"
            value={verifyEmail}
            onChange={(e) => setVerifyEmail(e.target.value)}
            className="border p-2 rounded flex-grow"
          />
          <button
            onClick={handleVerifyMail}
            className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
          >
            Verify Mail
          </button>
        </div>
      </section>
    </div>
    </div>
  );
};

export default Home;
